module.exports = __webpack_public_path__ + "images/feature/1203_new_feature_image-13533556babcd515facaff770c29d354.gif";